module.exports = __webpack_public_path__ + "img/dea-formazione-ico-stem.e2a8b3c9.svg";